import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ACCOUNT_TICKETS_FEATURE_KEY, AccountTicketsState } from './account-tickets.reducer';

export const accountTicketsState = createFeatureSelector<AccountTicketsState>(ACCOUNT_TICKETS_FEATURE_KEY);
// all tickets are combined account tickets and device tickets
export const getCombinedAllTickets = createSelector(accountTicketsState, (state: AccountTicketsState) => [
    ...state.deviceTickets,
    ...state.accountTickets
]);

export const getAllAccountTickets = createSelector(accountTicketsState, (state: AccountTicketsState) => state.all);
export const ticketsLoaded = createSelector(accountTicketsState, (state: AccountTicketsState) => state.loaded);

export const getTicket = (ticketId: number | string) => {
    return createSelector(accountTicketsState, (state: AccountTicketsState) => {
        const ticketIdInStr = String(ticketId);
        return [...state.accountTickets, ...state.deviceTickets].find((ticket) => {
            const docNum = ticket.docNumString ?? ticket.docNum;
            if (docNum !== null && docNum !== undefined) {
                return String(docNum) === ticketIdInStr;
            }
            return String(ticket.id) === ticketIdInStr;
        });
    });
};

export const allPagesLoaded = createSelector(accountTicketsState, (state: AccountTicketsState) => state.allPagesLoaded);

export const getDeviceTickets = createSelector(
    accountTicketsState,
    (state: AccountTicketsState) => state.deviceTickets
);

export const deviceTicketsLoaded = createSelector(
    accountTicketsState,
    (state: AccountTicketsState) => state.deviceTicketsLoaded
);

export const getPage = createSelector(accountTicketsState, (state: AccountTicketsState) => state.page);
export const latestLoadedPage = createSelector(
    accountTicketsState,
    (state: AccountTicketsState) => state.latestLoadedPage
);

export const shouldLoadPage = createSelector(accountTicketsState, (state: AccountTicketsState) =>
    state.page !== state.latestLoadedPage && state.latestLoadedPage !== -1 ? state.page : -1
);

export const offflinePagesLoaded = createSelector(
    accountTicketsState,
    (state: AccountTicketsState) => state.offlinePagesLoaded
);
